// extracted by mini-css-extract-plugin
export default {"ActionBox":"Container_ActionBox__UOY4I","Input":"Container_Input__QJ4cU","SpanMiddle":"Container_SpanMiddle__Glu6a"};